module.exports = __webpack_public_path__ + "img/home-btn.58f45d8e.svg";